import { Box, Typography } from "@material-ui/core";
import React from "react";

const InformationBox = ({ children, headerText = null }) => {
  return (
    <Box>
      {headerText && (
        <Box>
          <Typography>{headerText}</Typography>
        </Box>
      )}
      <Box>{children}</Box>
    </Box>
  );
};
export default InformationBox;
